import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import type { ThemeTypedColorProps } from "../../../../../themes/common";
import { theme } from "../../theme/toyotaTheme";

export const BadgeRounded = styled.button<{ hasLink?: boolean } & ThemeTypedColorProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: ${theme.colors.primaryBlack};
    background-color: ${theme.colors.primaryWhite};
    border: 2px solid ${theme.colors.primaryBlack};
    border-radius: 10px;

    ${({ hasLink }) =>
        hasLink &&
        css`
            cursor: pointer;
        `};

    &:not(:nth-last-child(1)) {
        margin-right: 4px;
    }

    html[dir="rtl"] & {
        &:not(:nth-last-child(1)) {
            margin-left: 4px;
            margin-right: 0;
        }
    }
`;

export const SpotlightWrapper = styled.span`
    margin-left: ${theme.space[1]}px;
    line-height: 1.4rem;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const Wrapper = styled.span<SpaceProps>`
    position: relative;
    top: -3px;
    margin-left: ${theme.space[1]}px;
    z-index: 100;
    ${space};

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;
